import { environment } from "src/environments/environment";
import { Component, Inject, PLATFORM_ID } from "@angular/core";
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from "@angular/router";

import { Platform, MenuController } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AuthService } from "./auth/auth.service";

import { ApiService } from "./services/api.service";
import { GlobalDataService } from "./services/global-data.service";
import { MenuItem } from "./types/menu";
import { UserInterface } from "./types/user";
import { SocialAuthService } from "angularx-social-login";
import { isPlatformBrowser } from "@angular/common";

/**
 * Declare global for GTM tag ref
 */
declare global {
  interface Window {
    gtag: any;
    formSubmitted: any;
    mappedin: any;
    instgrm: any;
  }
}
// let gtag = window && window?.gtag ? window?.gtag : undefined;

/**
 * AppComponent controls the application shell
 *
 * @export
 * @class AppComponent
 */
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  cordova: boolean = false;
  isBrowser: boolean = false;
  isMobile: boolean = false;
  showLoadingOverlay = true;
  keyboardState: string = "";
  environmentUrl: string;
  environmentSlug: string;
  headerMenu: MenuItem[] = [];

  ssoProfile;
  user: UserInterface;
  loginStateChecked: boolean = false;
  profileLinks: MenuItem[] = [
    {
      title: "My Profile",
      path: "/profile",
    },
    {
      title: "Log Out",
      path: "logout",
    },
  ];

  /**
   * Creates an instance of AppComponent.
   * @param {Platform} platform The platform service can be used to get information about your current device.
   * @param {SplashScreen} splashScreen The splashscreen displays and hides a splash screen during application launch.
   * @param {StatusBar} statusBar The status bar manages the appearance of the native status bar.
   * @memberof AppComponent
   */
  constructor(
    private API: ApiService,
    private authService: AuthService,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private menu: MenuController,
    private globalData: GlobalDataService,
    private socialAuthService: SocialAuthService,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    router.initialNavigation();
    
    this.environmentSlug = environment.environment_name;
    this.isBrowser = isPlatformBrowser(platformId);
    this.isMobile = this.platform.is("mobile") || this.platform.is("mobileweb");

    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);

      if (event instanceof NavigationEnd) {
        this.checkStoreProfile();
      }
    });

    this.checkStoreProfile();

    this.authService.dataChange.subscribe((user) => {
      if (!this.cordova) {
        this.user = user;
      }
    });

    this.initializeApp();
  }

  /**
   * Shows and hides the loading spinner during RouterEvent changes
   */
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.showLoadingOverlay = true;
    }
    if (event instanceof NavigationEnd) {
      setTimeout(() => {
        this.showLoadingOverlay = false;
      }, 300);
    }
    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.showLoadingOverlay = false;
    }
    if (event instanceof NavigationError) {
      this.showLoadingOverlay = false;
    }
  }

  /**
   * Fetch header and footer menu data
   */
  fetchData() {
    this.API.GET(`public/menus/${environment.mall_id}/header`).subscribe({
      next: (response) => {
        this.globalData.setMenuData("header", response);
        this.headerMenu = response;
      },
      error: () => {},
    });

    this.API.GET(`public/menus/${environment.mall_id}/footer`).subscribe({
      next: (response) => {
        this.globalData.setMenuData("footer", response);
      },
      error: () => {},
    });
  }

  /**
   * This method executes the platform ready promise.
   * Running global commands inside here will make sure the device is ready and able to access it's native plugins
   */
  initializeApp() {
    this.fetchData();
    this.environmentUrl = environment.api_base_url;

    this.platform.ready().then(() => {
      // if (this.platform.is("cordova")) {
      //   this.statusBar.styleDefault();
      //   this.splashScreen.hide();
      // }
      // window.addEventListener('keyboardWillShow', () => {
      //   this.keyboardState = 'keyboard-visible';
      // });
      // window.addEventListener('keyboardWillHide', () => {
      //   this.keyboardState = 'keyboard-hidden';
      // });
    });
  }

  /**
   * Navigate user to specified route with logout support
   */
  linkToPage(item) {
    this.menu.close();

    let url = item.path;

    if (url === "logout") {
      this.authService.logOut();

      if (
        this.user.social?.provider === "facebook" ||
        this.user.social?.provider === "google"
      )
        this.socialAuthService.signOut();

      this.user = undefined;
      this.router.navigate(["/"]);
    } else {
      if (url.indexOf("/") < 0) url = "/page/" + item.path;

      if (item.newWindow && typeof window !== "undefined") {
        window.open(url, "_blank");
      } else {
        this.router.navigateByUrl(url);
      }
    }
  }

  /**
   * Check for stored SSO profile
   */
  checkStoreProfile() {
    if (!this.cordova) this.user = this.authService.getUser();
    this.loginStateChecked = true;
  }
}
